module.exports = __webpack_public_path__ + "media/images/pc/special_reports/icon_balloon-f6ba38ed22e3fc373fef49086f113d5f.png";